/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-explicit-any */

export function isClient(): boolean {
  /* eslint-disable-next-line */
  if (!globalThis) var globalThis = require('globalthis')()
  return typeof globalThis.alert === 'function'
}

export const isProduction = (env: string) => 'production'.indexOf(env) !== -1

export const isEmptyObject = (obj?: Object) => !obj || Object.keys(obj).length === 0

export const checkObjectPropertiesUndefined = (obj: Object) =>
  Object.values(obj).every((el) => el === undefined) ? undefined : obj

export const debounce = (fn: Function, ms = 500) => {
  let timeoutId: ReturnType<typeof setTimeout>
  // eslint-disable-next-line func-names
  return function (this: any, ...args: any[]) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.apply(this, args), ms)
  }
}

export const deepGet = (
  obj: { [key: string]: any },
  path: string,
  defaultValue: any = undefined,
) => {
  const travel = (regexp: RegExp) =>
    String.prototype.split
      .call(path, regexp)
      .filter(Boolean)
      .reduce((res, key) => (res !== null && res !== undefined ? res[key] : res), obj)
  const result = travel(/[,[\]]+?/) || travel(/[,[\].]+?/)
  return result === undefined || result === obj ? defaultValue : result
}

export const getUniqueValues = <T, P = any>(prop: keyof T) => (items: T[]) => {
  return (Array.from(new Set(items.map(({ [prop]: value }) => value))).filter(
    Boolean,
  ) as unknown) as P[]
}
